/**
 * 受注一覧 処分事業場情報
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests`

 const manifest_maintenance_disposer_location = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/disposer_locations`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}/disposer_locations`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},

 }

 export default manifest_maintenance_disposer_location